module.exports = function(app) {
	'use strict';
	app.factory('eprSummaryModals', ['services', 'modal', 'employee', function(services, modal, employee) {
		var getGroupNumberOptions = function(data, modalScope) {
			var groupNumberOptions = [];
			for (var memberIndex = 0; memberIndex < data.length; ++memberIndex) {
				var member = data[memberIndex];
				if (groupNumberOptions.indexOf(member.groupId) < 0) {
					groupNumberOptions.push(member.groupId);
				}
			}
			modalScope.currentGroupNumber = groupNumberOptions[0];
			return groupNumberOptions;
		};

		var viewMedicareHistory = function(umi, groupSwitcher, modalScope, metadata) {
			return function() {
				var groupNumber = groupSwitcher.selection;
				metadata.loadingInProgressForModals = true;
				var mediInp = { umi: umi, groupNo: groupNumber }
				services.eprsvc.memberCOBHistory().fetch(mediInp).then(
					function(response) {
						metadata.loadingInProgressForModals = false;
						modalScope.modalData = response.data.payload;
						modalScope.groupNumberOptions = getGroupNumberOptions(modalScope.modalData, modalScope);

						modal.open({
							templateUrl: "_modals/medicare.employerTemplate.html/pages/employee/modals/medicareHistoryModal",
							scope: modalScope,
							classes: 'xl-modal'
						});
					},
					function(error) {
						metadata.loadingInProgressForModals = false;
						console.error('eprsvc.medicareCOBHistory().fetch() failed with:', error);
						modal.open({
							templateUrl: "_modals/error.employerTemplate.html/pages/employee/modals/reviewErrorModals",
							scope: modalScope,
							classes: 'xl-modal'
						});
					}
				);
			};
		};

		var viewOtherInsuranceHistory = function(umi, groupSwitcher, modalScope, metadata) {
			return function() {
				var groupNumber = groupSwitcher.selection;
				metadata.loadingInProgressForModals = true;
                var othInp = { umi: umi, groupNo: groupNumber };
				services.eprsvc.memberCOBHistory().fetch(othInp).then(
					function(response) {
						metadata.loadingInProgressForModals = false;
						modalScope.modalData = response.data.payload;
						modalScope.groupNumberOptions = getGroupNumberOptions(modalScope.modalData, modalScope);
						modal.open({
							templateUrl: "_modals/othInsHistory.employerTemplate.html/pages/employee/modals/otherInsuranceHistoryModal",
							scope: modalScope,
							classes: 'xl-modal'
						});
					},
					function(error) {
						metadata.loadingInProgressForModals = false;
						console.log('eprsvc.medicareCOBHistory().fetch() failed with:', error);
						modal.open({
							templateUrl: "_modals/error.employerTemplate.html/pages/employee/modals/reviewErrorModals",
							scope: modalScope,
							classes: 'xl-modal'
						});
					}
				);
			};
		};

		var viewOtherInsuranceAndMedicareHistory = function(umi, groupSwitcher, modalScope, metadata) {
			return function() {
				var groupNumber = groupSwitcher.selection;
				metadata.loadingInProgressForModals = true;
				modalScope.modalName = 'OthandMedi';
                var othAndMedInp = { umi: umi, groupNo: groupNumber };
				services.eprsvc.memberCOBHistory().fetch(othAndMedInp).then(
					function(response) {
						metadata.loadingInProgressForModals = false;
						modalScope.modalData = response.data.payload;
						modalScope.groupNumberOptions = getGroupNumberOptions(modalScope.modalData, modalScope);
						modal.open({
							templateUrl: "_modals/othInsMedicare.employerTemplate.html/pages/employee/modals/otherInsuranceAndMedicareHistoryModal",
							scope: modalScope,
							classes: 'large-modal'
						});
					},
					function(error) {
						metadata.loadingInProgressForModals = false;
						console.error('eprsvc.medicareCOBHistory().fetch() failed with:', error);
						modal.open({
							templateUrl: "_modals/error.employerTemplate.html/pages/employee/modals/reviewErrorModals",
							scope: modalScope,
							classes: 'largeplus-modal'
						});
					}
				);
			};
		};

		var viewPlanCoverage = function(umi, groupSwitcher, modalScope, metadata) {
			return function() {
				var groupNumber = groupSwitcher.selection;
				metadata.loadingInProgressForModals = true;
				var input = { umi: umi, groupNo: groupNumber };
				services.eprsvc.memberPlanHistory().fetch(input).then(
					function(response) {
						metadata.loadingInProgressForModals = false;
						modalScope.modalData = response.data.payload;

						modal.open({
							templateUrl: "_modals/planCoverage.employerTemplate.html/pages/employee/modals/planCoverageModal",
							scope: modalScope,
							classes: 'xl-modal'
						});
					},
					function(error) {
						metadata.loadingInProgressForModals = false;
						console.error('eprsvc.memberPlanHistory().fetch() failed with:', error);
						modal.open({
							templateUrl: "_modals/error.employerTemplate.html/pages/employee/modals/reviewErrorModals",
							scope: modalScope,
							classes: 'xl-modal'
						});
					}
				);
			};
		};

		var viewProviderModal = function(umi, groupSwitcher, modalScope, metadata) {
			return function() {
				var groupNumber = groupSwitcher.selection;
				metadata.loadingInProgressForModals = true;
				var ProviderInput = { umi: umi, groupNo: groupNumber }
				services.eprsvc.memberPCPHistory().fetch(ProviderInput).then(
					function(response) {
						metadata.loadingInProgressForModals = false;
						modalScope.modalData = response.data.payload;

						modal.open({
							templateUrl: "_modals/provider.employerTemplate.html/pages/employee/modals/providerHistoryModal",
							scope: modalScope,
							classes: 'xl-modal'
						});
					},
					function(error) {
						metadata.loadingInProgressForModals = false;
						console.error('eprsvc.memberPCPHistory().fetch() failed with:', error);
						modal.open({
							templateUrl: "_modals/error.employerTemplate.html/pages/employee/modals/reviewErrorModals",
							scope: modalScope,
							classes: 'xl-modal'
						});
					}
				);
			};
		};

		var viewReportCodeHistory = function(umi, groupSwitcher, modalScope, metadata) {
			return function() {
				var groupNumber = groupSwitcher.selection;
				metadata.loadingInProgressForModals = true;
				modalScope.modalName = 'ReportCodes';
				//Changes for PM78639
				var repPay = { umi: umi, groupNo: groupNumber };
				services.eprsvc.memberReportCodeHistory().fetch(repPay).then(
					function(response) {
						metadata.loadingInProgressForModals = false;
						modalScope.modalData = response.data.payload;
						modal.open({
							templateUrl: "_modals/reportCode.employerTemplate.html/pages/employee/modals/reportCodeModal",
							scope: modalScope,
							classes: 'large-modal'
						});
					},
					function(error) {
						metadata.loadingInProgressForModals = true;
						console.error('eprsvc.memberReportCodeHistory().fetch() failed with:', error);
						modal.open({
							templateUrl: "_modals/error.employerTemplate.html/pages/employee/modals/reviewErrorModals",
							scope: modalScope,
							classes: 'large-modal'
						});
						metadata.loadingInProgressForModals = false;
					}
				);
			};
		};

		return {
			viewOtherInsuranceHistory: viewOtherInsuranceHistory,
			viewOtherInsuranceAndMedicareHistory: viewOtherInsuranceAndMedicareHistory,
			viewPlanCoverage: viewPlanCoverage,
			viewProviderModal: viewProviderModal,
			viewMedicareHistory: viewMedicareHistory,
			viewReportCodeHistory: viewReportCodeHistory
		};
	}]);
};
